"use client";

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { UserPlus, LogIn, Loader2 } from 'lucide-react';

export default function GuestPaywallButtons() {
  const [isNavigating, setIsNavigating] = useState(false);
  const [activeButton, setActiveButton] = useState<'signup' | 'signin' | null>(null);
  const router = useRouter();

  const handleNavigation = async (path: string, buttonType: 'signup' | 'signin') => {
    if (isNavigating) return;
    
    setIsNavigating(true);
    setActiveButton(buttonType);
    
    // Small delay to show loading state before navigation
    setTimeout(() => {
      router.push(path);
    }, 150);
  };

  return (
    <div className="space-y-3">
      <Button 
        onClick={() => handleNavigation('/register', 'signup')}
        disabled={isNavigating}
        className="w-full" 
        size="lg"
      >
        {isNavigating && activeButton === 'signup' ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Creating Account...
          </>
        ) : (
          <>
            <UserPlus className="h-4 w-4 mr-2" />
            Create Free Account
          </>
        )}
      </Button>
      
      <Button 
        variant="outline" 
        onClick={() => handleNavigation('/login', 'signin')}
        disabled={isNavigating}
        className="w-full"
      >
        {isNavigating && activeButton === 'signin' ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Signing In...
          </>
        ) : (
          <>
            <LogIn className="h-4 w-4 mr-2" />
            Sign In
          </>
        )}
      </Button>
    </div>
  );
} 